module.exports = __webpack_public_path__ + "img/home-two4.a46655da.png";